import { useLayoutEffect, useState } from "react";

// The login footer (Footer.module.css) is position: fixed, so it sits over the bottom of the page.
// Returns its height: pad the form's bottom by it and the last control can scroll above the footer.
// Measured, not hard-coded: at 375px the footer wraps to ~235px, on desktop it is ~70px.
const useFooterClearance = () => {
  const [clearance, setClearance] = useState(0);

  useLayoutEffect(() => {
    const footer = document.querySelector("footer");
    if (!footer) return undefined;
    const measure = () => setClearance(Math.ceil(footer.getBoundingClientRect().height));
    measure();
    if (typeof ResizeObserver === "undefined") return undefined;
    const observer = new ResizeObserver(measure);
    observer.observe(footer);
    return () => observer.disconnect();
  }, []);

  return clearance;
};

export default useFooterClearance;
